import React, { useState, useEffect, useCallback } from "react";
import { auth } from "../../firebase";
import { signOut } from "firebase/auth";
import styled from "styled-components";
import DrawerKonularim from "./Drawers/studentDrawerKonularim";
import DrawerBasarilarim from "./Drawers/studentDrawerBasarilarim";
import StudentDrawerOdevlerim from "./Drawers/studentDrawerOdevlerim";
import DrawerOgretmenlerim from "./Drawers/studentDrawerOgretmenlerim";
import DrawerSiniflarim from "./Drawers/studentDrawerSiniflarim";
import { getDocs, query, collection, where, limit } from "firebase/firestore";
import { db } from "../../firebase";
import { Container } from "../../style/global/styledComponents/Containers";
import DrawerDokumanAra from "../teacher/Drawers/DrawerDokumanAra";

function StudentPanel() {
  const [user, setUser] = useState(null);
  const [avatarUrl, setAvatarUrl] = useState(null);

  useEffect(() => {
    const currentUser = auth.currentUser;
    if (!currentUser) return;

    // 📌 1. localStorage kontrolü (ama UID doğrulamasıyla)
    const cachedUserRaw = localStorage.getItem("studentUser");
    if (cachedUserRaw) {
      const cachedUser = JSON.parse(cachedUserRaw);

      if (cachedUser?.uid === currentUser.uid) {
        // UID eşleşiyorsa, local veriyi kullan
        setUser(cachedUser);
        if (cachedUser?.userData?.avatar) {
          setAvatarUrl(
            `${process.env.PUBLIC_URL}/avatars/avatar${cachedUser.userData.avatar}.png`
          );
        }
        return;
      } else {
        // UID farklıysa, eski kullanıcıya ait veriyi temizle
        localStorage.removeItem("studentUser");
        localStorage.removeItem("studentActiveDiv");
      }
    }

    // 📌 2. Firestore'dan yeni kullanıcıyı çek
    const q = query(
      collection(db, "users"),
      where("uid", "==", currentUser.uid),
      limit(1)
    );

    const fetchUser = async () => {
      const snapshot = await getDocs(q);
      snapshot.forEach((doc) => {
        const userData = doc.data();
        setUser(userData);
        localStorage.setItem("studentUser", JSON.stringify(userData));

        if (userData?.userData?.avatar) {
          setAvatarUrl(
            `${process.env.PUBLIC_URL}/avatars/avatar${userData.userData.avatar}.png`
          );
        }
      });
    };

    fetchUser();
  }, []);

  const [activeDiv, setActiveDiv] = useState(() => {
    const storedActiveDiv = localStorage.getItem("studentActiveDiv");
    return storedActiveDiv ? parseInt(storedActiveDiv, 10) : 1;
  });

  const handleSignOut = useCallback(() => {
    // ✅ Çıkışta cache temizle
    localStorage.removeItem("studentUser");
    localStorage.removeItem("studentActiveDiv");
    signOut(auth);
  }, []);

  const handleButtonClick = (divNumber) => {
    setActiveDiv(divNumber);
    localStorage.setItem("studentActiveDiv", divNumber);
  };

  return (
    <Container>
      <NameBarUp>
        <NameBar>
          <Avatar>
            {avatarUrl && (
              <img
                src={avatarUrl}
                alt="Avatar"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
            )}
          </Avatar>

          <NameBarDown>
            <Name>{user && <p>{user.userData.displayName}</p>}</Name>
            <Description>
              {user && <p>{user.userData.selfIntroduction}</p>}
            </Description>
          </NameBarDown>
        </NameBar>
      </NameBarUp>
      <Main>
        <ButtonBar>
          <DivFlex1 style={{ marginBottom: "1.5rem" }}>
            <Text>Hoş Geldiniz</Text>
          </DivFlex1>
          <DivFlex onClick={() => handleButtonClick(1)}>
            <Button>Konularım</Button>
          </DivFlex>
          <DivFlex onClick={() => handleButtonClick(6)}>
            <Button>Ödevlerim</Button>
          </DivFlex>
          <DivFlex onClick={() => handleButtonClick(2)}>
            <Button>Başarılarım</Button>
          </DivFlex>
          <DivFlex onClick={() => handleButtonClick(3)}>
            <Button>Öğretmenlerim</Button>
          </DivFlex>
          <DivFlex onClick={() => handleButtonClick(4)}>
            <Button>Sınıflarım</Button>
          </DivFlex>
          <DivFlex onClick={() => handleButtonClick(5)}>
            <Button>Döküman Ara</Button>
          </DivFlex>
          <DivFlex onClick={handleSignOut}>
            <Button>Çıkış</Button>
          </DivFlex>
        </ButtonBar>
        <ObjectBar>
          <div style={{ display: activeDiv === 1 ? "block" : "none" }}>
            <DrawerKonularim />
          </div>
          <div style={{ display: activeDiv === 2 ? "block" : "none" }}>
            <DrawerBasarilarim />
          </div>
          <div style={{ display: activeDiv === 3 ? "block" : "none" }}>
            <DrawerOgretmenlerim />
          </div>
          <div style={{ display: activeDiv === 4 ? "block" : "none" }}>
            <DrawerSiniflarim />
          </div>
          <div style={{ display: activeDiv === 5 ? "block" : "none" }}>
            <DrawerDokumanAra />
          </div>
          <div style={{ display: activeDiv === 6 ? "block" : "none" }}>
            <StudentDrawerOdevlerim />
          </div>
        </ObjectBar>
      </Main>
    </Container>
  );
}

export const NameBarUp = styled.div`
  background-color: #f8f8ff;
  width: 100%;
  padding-left: 10px;
  padding-top: 20px;
  border-top: 2px solid var(--main-color);
  display: flex;
  justify-content: center;
`;
export const NameBar = styled.div`
  width: 90%;
  display: flex;
  max-width: var(--main-width);
`;

export const Avatar = styled.div`
  flex: 0 0 100px;
  margin-right: 20px;
  height: auto;
  overflow-y: hidden;
`;

export const NameBarDown = styled.div`
  flex: 1;
  height: auto;
  padding: 10px;
`;

export const Name = styled.div`
  display: flex;
  justify-content: start;
  align-items: end;
  font-weight: bold;
  font-size: 20px;
`;

export const Description = styled.div`
  flex: 1;
`;

export const Main = styled.div`
  display: flex;
  width: 100%;
  background-color: #fff;
  max-width: var(--main-width);
  align-items: start;
  justify-content: start;

  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
  }
`;
export const DivFlex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 90px;
    margin-bottom: 0.3rem;
  }
`;

export const DivFlex1 = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1rem;
  cursor: pointer;

  @media (max-width: 768px) {
    width: 0px;
  }
`;

export const ButtonBar = styled.div`
  display: flex;
  flex-direction: column;
  margin: 1rem;

  @media (max-width: 768px) {
    flex-direction: row;
    flex-wrap: wrap;
    width: 100%;
    justify-content: space-evenly;
    margin: 1rem 0rem;
  }
`;

export const Button = styled.button`
  border: none;
  font-size: 1.1rem;
  background-color: white;
  color: var(--main-color);
  cursor: pointer;
  padding: 5px;
  min-width: 150px;
  border: 1px solid var(--main-color);
  border-radius: 5px;
  font-family: "MyCustomFont", sans-serif;

  :hover {
    background-color: var(--main-color);
    color: white;
    border-radius: 5px;
  }

  @media (max-width: 768px) {
    margin-right: 5px;
    font-size: 0.6rem;
    width: 100%;
    min-width: min-content;
  }
`;

export const Text = styled.div`
  font-size: 1.3rem;
  font-weight: bold;
  color: var(--main-color);

  @media (max-width: 768px) {
    display: none;
  }
`;

export const ObjectBar = styled.div`
  flex: 1;
  margin: 1rem;
  width: 94%;
`;

export default StudentPanel;
